var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 70,
    viewBox: "0 0 68 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_2141)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67303 21.8079C8.67303 28.9756 14.4798 34.7197 21.7257 34.7197C28.9691 34.7197 34.7784 28.9756 34.7784 21.8079C34.7784 14.6402 28.9691 8.89618 21.7257 8.89618C14.4798 8.89618 8.67303 14.6402 8.67303 21.8079ZM41.4524 49.3389C41.4524 42.7038 32.3654 41.0437 21.7263 41.0437C11.0293 41.0437 2.00011 42.7609 2.00011 49.4012C2.00011 56.0364 11.0871 57.6965 21.7263 57.6965C32.4232 57.6965 41.4524 55.9792 41.4524 49.3389Z",
    fill: "url(#paint0_linear_0_2141)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_2141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0105 45.2992C32.5063 45.2992 38.0544 46.4017 38.0544 50.8083C38.0544 55.2184 32.5416 56.3588 26.0105 56.3588C19.5147 56.3588 13.9666 55.2563 13.9666 50.8497C13.9666 46.4397 19.4794 45.2992 26.0105 45.2992Z",
    fill: "#0062FF",
    fillOpacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_2141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9154 28.3412C21.2686 28.3412 18.346 25.3892 18.346 21.7054C18.346 18.0217 21.2686 15.0697 24.9154 15.0697C28.561 15.0697 31.4849 18.0217 31.4849 21.7054C31.4849 25.3892 28.561 28.3412 24.9154 28.3412Z",
    fill: "#0062FF",
    fillOpacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_0_2141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_0_2141",
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 3,
    width: 54,
    height: 66,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 14,
    y: 3,
    width: 54,
    height: 66
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0127 20.933C24.0127 30.333 31.6279 37.866 41.1305 37.866C50.6298 37.866 58.2484 30.333 58.2484 20.933C58.2484 11.533 50.6298 4 41.1305 4C31.6279 4 24.0127 11.533 24.0127 20.933ZM67 57.0395C67 48.3379 55.0829 46.1608 41.1303 46.1608C27.1019 46.1608 15.2606 48.4129 15.2606 57.1213C15.2606 65.8229 27.1777 68 41.1303 68C55.1587 68 67 65.7479 67 57.0395Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0127 20.933C24.0127 30.333 31.6279 37.866 41.1305 37.866C50.6298 37.866 58.2484 30.333 58.2484 20.933C58.2484 11.533 50.6298 4 41.1305 4C31.6279 4 24.0127 11.533 24.0127 20.933ZM67 57.0395C67 48.3379 55.0829 46.1608 41.1303 46.1608C27.1019 46.1608 15.2606 48.4129 15.2606 57.1213C15.2606 65.8229 27.1777 68 41.1303 68C55.1587 68 67 65.7479 67 57.0395Z",
    fill: "#3EA0FE",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1305 38.866C31.0859 38.866 23.0127 30.8955 23.0127 20.933H25.0127C25.0127 29.7706 32.1699 36.866 41.1305 36.866V38.866ZM59.2484 20.933C59.2484 30.8957 51.1717 38.866 41.1305 38.866V36.866C50.0879 36.866 57.2484 29.7704 57.2484 20.933H59.2484ZM41.1305 3C51.1717 3 59.2484 10.9703 59.2484 20.933H57.2484C57.2484 12.0956 50.0879 5 41.1305 5V3ZM23.0127 20.933C23.0127 10.9705 31.0859 3 41.1305 3V5C32.1699 5 25.0127 12.0955 25.0127 20.933H23.0127ZM41.1303 45.1608C48.1288 45.1608 54.7357 45.703 59.624 47.3919C62.0742 48.2385 64.1646 49.3971 65.6503 50.9857C67.158 52.5978 68 54.6093 68 57.0395H66C66 55.119 65.3524 53.5952 64.1896 52.3518C63.0048 51.0849 61.2439 50.0676 58.9708 49.2823C54.4124 47.7073 48.0844 47.1608 41.1303 47.1608V45.1608ZM14.2606 57.1213C14.2606 54.6916 15.0962 52.6756 16.5962 51.0555C18.0749 49.4584 20.1578 48.2888 22.6041 47.4317C27.4843 45.7219 34.0923 45.1608 41.1303 45.1608V47.1608C34.1399 47.1608 27.8131 47.7259 23.2654 49.3192C20.998 50.1136 19.2437 51.1399 18.0638 52.4143C16.9052 53.6657 16.2606 55.1968 16.2606 57.1213H14.2606ZM41.1303 69C34.1318 69 27.5249 68.4579 22.6366 66.7689C20.1864 65.9223 18.096 64.7638 16.6103 63.1751C15.1026 61.563 14.2606 59.5516 14.2606 57.1213H16.2606C16.2606 59.0418 16.9082 60.5656 18.071 61.809C19.2558 63.0759 21.0167 64.0932 23.2898 64.8786C27.8482 66.4536 34.1762 67 41.1303 67V69ZM68 57.0395C68 59.4692 67.1644 61.4852 65.6644 63.1054C64.1856 64.7025 62.1028 65.8721 59.6565 66.7292C54.7763 68.439 48.1683 69 41.1303 69V67C48.1207 67 54.4475 66.435 58.9951 64.8417C61.2626 64.0472 63.0169 63.0209 64.1968 61.7466C65.3554 60.4952 66 58.9641 66 57.0395H68Z",
    fill: "url(#paint1_linear_0_2141)",
    mask: "url(#path-4-outside-1_0_2141)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_2141",
    x: -11,
    y: -4.10382,
    width: 65.4524,
    height: 74.8003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_2141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_2141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_2141",
    x: 0.966553,
    y: 32.2992,
    width: 50.0879,
    height: 37.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_0_2141"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_2141",
    x: 3.34595,
    y: 0.0696869,
    width: 43.1389,
    height: 43.2715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_0_2141"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_0_2141",
    x: -0.739502,
    y: -12,
    width: 83.7395,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_2141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_2141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_2141",
    x1: 18.8218,
    y1: 36.5642,
    x2: 55.9472,
    y2: 51.1576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39AFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A76FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_2141",
    x1: 58.7639,
    y1: 11.4561,
    x2: 17.0011,
    y2: 53.2715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassUsers);
export default __webpack_public_path__ + "static/media/GlassUsers.3d8687831c10a035bed82ecca360e7ac.svg";
export { ForwardRef as ReactComponent };